import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';
import { RedirectTransactionService } from '../../shared/services/business-transaction/redirect-transaction.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { WIPStatusType } from '../../wip/models/enums/w-i-p-status-type.enum';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';

@Injectable()
export class UserTransactionNavGuard implements CanActivate {
    private WipStatuses: WIPStatusType = new WIPStatusType();

    constructor(
        public modalService: MvdModalService,
        public redirectTransactionService: RedirectTransactionService,
        public transactionService: BusinessTransactionService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let bodyChild = route.children.find(c => c.outlet === 'body');
        let validStatuses: number[] = bodyChild && bodyChild.data && bodyChild.data.statuses ? bodyChild.data.statuses : [this.WipStatuses.Active.id, this.WipStatuses.Inactive.id];
        let businessTransactionNumberId: string = route.paramMap.get('id') || route.firstChild.paramMap.get('id');
        return this.transactionService.getTransactionMetaData(businessTransactionNumberId)
            .pipe(
                map(result => {
                    let validStatus: boolean = validStatuses.includes(result.wipStatusTypeId);
                    this.modalService.closeAll();
                    if (!validStatus) {
                        this.handleFail(businessTransactionNumberId);
                    }
                    return validStatus;
                })
            );
    }

    handleFail(businessTransactionNumberId: string) {
        this.modalService.confirm().body('Transaction Not At This Step. Navigate To Correct Page?').title('Navigate To Transaction?').cancelBtn('Cancel').okBtn('Ok')
            .okBtnFunc(() => this.redirectTransactionService.redirectToTransaction(businessTransactionNumberId)).open(ModalSize.Small);
    }

}
